/**
 * The colour used in the background of the logo.
 */
export const LOGO_COLOR = {
  hue: 213,
  saturation: 79,
  lightness: 45,
};

/**
 * The colours used to accent the UI.
 */
export const ACCENT_COLOR = {
  main: {
    hue: 213,
    saturation: 25,
    lightness: 71,
  },
  darker: {
    hue: 213,
    saturation: 93,
    lightness: 33,
  },
  contrastText: {
    hue: 213,
    saturation: 36,
    lightness: 21,
  },
  background: {
    hue: 213,
    saturation: 37,
    lightness: 68,
  },
  backgroundContrastText: {
    hue: 213,
    saturation: 11,
    lightness: 24,
  },
};
